import type { z } from 'zod';

/** First message per field, in schema order. */
export type FieldErrors = Record<string, string>;

export function fieldErrors(schema: z.ZodType, values: unknown): FieldErrors {
  const result = schema.safeParse(values);
  const errors: FieldErrors = {};
  if (!result.success) {
    for (const issue of result.error.issues) {
      const field = String(issue.path[0] ?? '');
      if (!(field in errors)) errors[field] = issue.message;
    }
  }
  return errors;
}

/**
 * Validate on blur, then on every change once touched: an error shows only for a touched field,
 * or for every field once a submit was attempted.
 */
export function visibleErrors(
  errors: FieldErrors,
  touched: ReadonlySet<string>,
  submitted: boolean,
): FieldErrors {
  return Object.fromEntries(
    Object.entries(errors).filter(([field]) => submitted || touched.has(field)),
  );
}

/** The field a failed submit should focus: the first error, in schema order. */
export const firstInvalid = (errors: FieldErrors): string | undefined => Object.keys(errors)[0];
